module.exports = __webpack_public_path__ + "img/streaming.c860f0ea.svg";